import {DefaultSchemaName} from '@app/views/admin/application-settings/models/data-source-config.model';

export class PIIShieldLevelConfig {
    constructor(
        public levelModels: PIIShieldLevelModel[],
        public rosterType: string
    ) { }
}
export class PIIShieldLevelModel {
    constructor(
        public piiLevel: PII_LEVEL,
        public maskedFields: string[] = <string[]>[]
    ) { }
}

export class PIIShieldIntegrationLevel {
    constructor(
        public integrationId: string,
        public districtGuid: string,
        public vendorOrgGuid: string,
        public piiLevel: PII_LEVEL
    ) { }
}

export class PIIShieldApplicationLevel {
    constructor(
        public vendorAppId: string,
        public vendorOrgGuid: string,
        public piiLevel: PII_LEVEL
    ) { }
}

export class PIIShieldVendorAppLevel {
    constructor(
        public applicationGuid: string,
        public vendorOrgGuid: string,
        public piiLevel: PII_LEVEL
    ) { }
}
export enum PII_LEVEL {
    null = '0',
    one = '1',
    two = '2',
    three = '3'
}

export const EDUTONE_USER_TASKS_PII_SHIELD_SUPPORTED = ['Student', 'Contact', 'Staff'];
export const SFTP_DATA_SCHEME_PII_SHIELD_SUPPORTED = [DefaultSchemaName.ONE_ROSTER_11, DefaultSchemaName.BASIC_ROSTER];
